import { render, staticRenderFns } from "./FinancesButtons.vue?vue&type=template&id=5b36ef78&"
import script from "./FinancesButtons.vue?vue&type=script&lang=js&"
export * from "./FinancesButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports